export default __webpack_public_path__ + "static/0046-cb9062fd99600a88a627e99ff17af665.png";